import { render, staticRenderFns } from "./SenderEmailUpdate.vue?vue&type=template&id=40f0e1a8&"
import script from "./SenderEmailUpdate.vue?vue&type=script&lang=js&"
export * from "./SenderEmailUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports